export default {
	props: ['toSection']
}
